<template>
  <div class="box box--purple">
    <h2 class="box__title">{{ $t('boxes.conversions.title')}}</h2>
    <ul class="list mb--small collumns--bordered">
      <li  class="list__item " v-for="click in visitors.clicks" :key="click.identifier">
        <h3 class="list__title">{{ $t('boxes.conversions.linkIdentifier', { identifier: click.identifier }) }}</h3>
        <div class="text-nowrap">
          {{ click.conversions }}
          <span class="fz--small">{{ click.percentage }}%</span>
        </div>
      </li>
    </ul>
    <ul class="list mb--small">
      <li  class="list__item">
        <h3 class="list__title">{{ $t('boxes.conversions.subscriptionIdentifier') }}</h3>
        <div class="text-nowrap">
          {{ visitors.registered_emails }}
          <span class="fz--small">{{ visitors.registeredEmailsPercentage }}%</span>
        </div>
      </li>
    </ul>
    <router-link class="button button--small--purple" :to="{ name: 'EmailList', params: { locale: i18n.locale, slug: $route.params.pageIdentifier }}">
      {{ $t('boxes.conversions.showEmails') }}
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import i18n from '../../../../i18n';

export default {
  data() {
    return {
      i18n,
    };
  },
  computed: mapGetters({
    visitors: 'metrics/visitors',
  }),
};
</script>



// WEBPACK FOOTER //
// src/screens/Metrics/components/boxes/Conversions.vue